import Education from './education'

export default Education
